import CampaignMappingFieldModelBase from '../_generated/modelBases/campaign-mapping-field-model-base';

export default class CampaignMappingFieldModel extends CampaignMappingFieldModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
